import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface Vendor {
  id: string;
  displayName: string;
}

export interface PackageVersions {
  allotropy: string;
  benchlingAsmParser: string;
}

export function convertToAsm(blobOrFileId: string, vendor: string): Promise<{blobId: string}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/connect-files:convert-to-asm',
    data: {blobOrFileId, vendor},
  });
}

export function convertToCsv(
  blobOrFileId: string,
  transformType?: string,
  mapperConfig?: string | null,
  newBlobName?: string,
  asmVendor?: string
): Promise<Array<{blobId: string; transformDataType: string}>> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/connect-files:convert-to-csv',
    data: {blobOrFileId, transformType, mapperConfig, newBlobName, asmVendor},
  });
}

export function getPackageVersions(): Promise<PackageVersions> {
  return net.getJSONPromise('/1/api/connect-files/package-versions');
}

export function listVendors(): Promise<Array<Vendor>> {
  return net.getJSONPromise('/1/api/connect-files/vendors');
}

export function createBlobFromFile(fileId: string): Promise<{blobId: string}> {
  return net.postJSONPromise({
    url: '/1/api/instruments/connect-files/create-blob-from-file',
    data: {fileId},
  });
}

export function createFileFromBlob(
  blobId: string,
  folderId: string,
  connectionId: string,
  lineageParentId?: string,
  transformDataType?: string
): Promise<{fileId: string}> {
  return net.postJSONPromise({
    url: '/1/api/instruments/connect-files/create-file-from-blob',
    data: {blobId, folderId, connectionId, lineageParentId, transformDataType},
  });
}

export function getSpreadsheetColumns(
  fileId: string,
  connectionSchemaId: string,
  transformDataType: string,
  delimiter?: string,
  inferDataTypes?: boolean
): Promise<{columns: Array<string>; data_types?: Array<string>}> {
  return net.postJSONPromise({
    url: '/1/api/instruments/connect-files/get-spreadsheet-columns',
    data: {fileId, connectionSchemaId, transformDataType, delimiter, inferDataTypes},
  });
}
